<video #video playsinline [hidden]="!isScanning"></video>
<canvas #canvas style="display: none"></canvas>
<ion-button *ngIf="isScanning" (click)="stopScan()" class="back-button-scanner">
  <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
  {{ 'i18n.common.back' | translate }}
</ion-button>
